// extracted by mini-css-extract-plugin
module.exports = {"label":"TableCountLabel_label__EYN78"};